const baseReportUrl = "Report"



  const endpoints = {
    getMostViewedAdvertTypesChart:`${baseReportUrl}/MostViewedAdvertTypesChart`,
    
 
  };
  
  export default endpoints;
  